import { render, staticRenderFns } from "./DashBoardPlugin.vue?vue&type=template&id=ba45845a&scoped=true"
import script from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
export * from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
import style0 from "./DashBoardPlugin.vue?vue&type=style&index=0&id=ba45845a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba45845a",
  null
  
)

export default component.exports